import { Checkbox } from "native-base";

export default Checkbox;